import { combineReducers } from 'redux';
import main from './reducers/main';
import notify from './reducers/notification';
import sign from './reducers/sign';
import posts from './reducers/posts';
import profile from './reducers/profile';
import team from './reducers/team';
//import counter from './counter'
const MainReducer = combineReducers({
    main,
    notify,
    sign,
    posts,
    profile,
    team
});

export default MainReducer;